import { action as apiAction } from 'api/Api'
import {
  removeItem as removeItemFromChecklist
} from '../redux/elements'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  checklistItemId: number
  checklistId: number
  userId?: number
  statusId?: number
  template?: any
  groupTarget?: any
  position?: number
}

const requestConvertChecklistItemToSubCard = (payload: Payload) => async dispatch => {
  const { checklistItemId, checklistId, statusId, userId, template, groupTarget, position } = payload

  const args: any = {
    checklistItemId,
    userId,
    template,
    groupTarget
  }

  if (statusId || position) {
    args.cardTarget = {
      statusId,
      statusPosition: position ? position : 0
    }
  }

  const optimisticAction = optimisticDispatch(dispatch, removeItemFromChecklist({
    elementId: checklistId,
    itemId: checklistItemId
  }))

  try {
    await apiAction('ConvertChecklistItemToSubCardListItem', args)

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    throw error
  }
}

export default requestConvertChecklistItemToSubCard